import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  children: React.ReactNode;
}

const Wrap = styled.div`
  display: flex;
  flex-flow: column wrap;

  @media ${device.mobile} {
    flex-flow: row nowrap;
  }

  > * {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    @media ${device.mobile} {
      margin: 0 20px;
    }
  }
`;

export const DownloadLinks = ({ children }: IProps) => {
  return <SliceWrapper left={<Wrap>{children}</Wrap>} />;
};
